import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ProcessRouteHeaderReferenceService extends BaseReferenceService {
  constructor() {
    super('ProcessRouteHeaderReference');
  }
}
